import React, { CSSProperties, ReactNode } from 'react';
import { GenerallyIconType, getGenerallyIconElement } from './GenerallyIcons';
import './IconWithCaptionButton.css';
import { exportGoogleAnalytics } from '~/shared/utils';

export type ButtonType = 'high' | 'basic' | 'sub' | 'cancel' | 'danger';

export interface IconWithCaptionButtonProps {
  name: string;
  icon?: ReactNode;
  iconType?: GenerallyIconType;
  buttonType?: ButtonType;
  caption?: string;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  onClick: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
export const IconWithCaptionButton = (props: IconWithCaptionButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    props.onClick(e);
    // GoogleAnalyticsへデータ送信
    exportGoogleAnalytics('button', { targetName: props.name });
  };

  return (
    <button
      type="button"
      className={`IconWithCaptionButton ${props.buttonType || ''} ${
        props.className || ''
      }`}
      onClick={handleClick}
      disabled={props.disabled}
      style={props.style}
    >
      <span className="button-inner">
        <span className="icon">
          {!props.icon &&
            props.iconType &&
            getGenerallyIconElement(props.iconType)}
          {props.icon || null}
        </span>
        {props.caption && <span className="caption">{props.caption}</span>}
      </span>
    </button>
  );
};
